/* eslint-disable no-undef */

// logic for navbar dropdown
$('body').on('click', '#nav_btn, .close_main_menu', function (e) {
  e.preventDefault();
  $('.main-navbar').toggle('slide', function () {
    if (!$(this).is(':visible')) {
      $(this).removeAttr('style');
    }
  });
  $('body').toggleClass('mobile-menu-open');
});

$('body').on('click', '.close_sub_menu', function (e) {
  e.preventDefault();
  const sel = $(this).parents('.wmdropdown:last').find('[data-toggle="wmdropdown"]');
  sel.trigger('click');
});

$('.navbar .wmdropdown').on('show.bs.wmdropdown', function () {
  const winWidth = window.outerWidth;
  if (winWidth > 720) {
    $(this).find('.wmdropdown-menu').first().stop(true, true).slideDown(300);
  } else {
    $(this).find('.wmdropdown-menu').first().stop(true, true).toggle('slide');
  }
  $(this).addClass('dd-open');
  $(this).find('.wmdropdown-menu').children('.wmdropdown-content').addClass('wmdropdown-open');
  $('body').addClass('over_hide');
  $('.custom-modal-backdrop').addClass('show');
  $('.custom-modal-backdrop').addClass('modal-backdrop');
  $('.cbg_color').addClass('custom_nav');
});

$('.navbar .wmdropdown').on('hide.bs.wmdropdown', function () {
  const winWidth = window.outerWidth;
  if (winWidth > 720) {
    $(this).find('.wmdropdown-menu').first().stop(true, true).slideUp(300);
  } else {
    $(this).find('.wmdropdown-menu').first().stop(true, true).toggle('slide');
  }
  $(this).removeClass('dd-open');
  $(this).find('.wmdropdown-menu').children('.wmdropdown-content').removeClass('wmdropdown-open');
  $('body').removeClass('over_hide');
  $('.custom-modal-backdrop').addClass('show');
  $('.custom-modal-backdrop').removeClass('modal-backdrop');
  $('.cbg_color').removeClass('custom_nav');
});

const getNavSectionList = (items, sectionTitle, colPrefix, type) => {
  let content = `<div class="sectionHeader">
      <h3 class="sectionTitle featured">Featured ${sectionTitle}</h3>
    </div>`;
  content += '<ul>';
  items.forEach((item) => {
    if (item.public_view) {
      content += `<li>
                <a href="${loadUrl('base', `${type}/${item[colPrefix + '_url_name']}`)}">
                  <img src="${loadUrl('images', `${item[colPrefix + '_squared_logo_image_name']}`)}" alt="${item[colPrefix + '_name']}" />
                  <span class="description">
                    <span class="title">${item[colPrefix + '_name']}</span>
                    <span class="subtitle">${item[colPrefix + '_quote'] ?? ''}</span>
                  </span>
                </a>
              </li>`;
    } else if (isAdmin && !item.public_view) {
      content += `<li>
                <a href="${loadUrl('base', `${type}/${item[colPrefix + '_url_name']}`)}">
                  <img src="${loadUrl('images', `${item[colPrefix + '_squared_logo_image_name']}`)}" alt="${item[colPrefix + '_name']}" />
                  <span class="description">
                    <span class="title">${item[colPrefix + '_name']}</span>
                    <span class="subtitle">${item[colPrefix + '_quote'] ?? ''}</span>
                  </span>
                </a>
              </li>`;
    }
  });
  content += '</ul>';
  content += `<div class="view_more_nav">
                <a class="btn" href="${loadUrl('base', type)}">
                  <img src="${loadUrl('images', 'menu_images/right-arrow.png')}" class="btn_arrow" />
                  View All ${sectionTitle}
                </a>
              </div>`;
  return content;
};

// Fetch resort brands
$.ajax({
  type: 'GET',
  url: loadUrl('api', 'resort-brands' + '?v=' + cacheControlVersion),
  success: function (response) {
    const container = document.getElementsByClassName('featured_resorts')[0];
    if (response.data.length > 0) {
      container.innerHTML = getNavSectionList(response.data, 'Resorts', 'rb', 'hotels-resorts');
      container.style.display = 'block';
    } else {
      container.style.display = 'none';
    }
  }
});

// Fetch tour operators
$.ajax({
  type: 'GET',
  cache: true,
  url: loadUrl('api', 'tour-operators' + '?v=' + cacheControlVersion),
  success: function (response) {
    const container = document.getElementsByClassName('featured_tours')[0];
    if (response.data.length > 0) {
      container.innerHTML = getNavSectionList(response.data, 'Tour Operators', 'to', 'tours');
      container.style.display = 'block';
    } else {
      container.style.display = 'none';
    }
  }
});

// Fetch Cruise lines
$.ajax({
  type: 'GET',
  url: loadUrl('api', 'cruise-lines' + '?v=' + cacheControlVersion),
  cache: true,
  success: function (response) {
    const container = document.getElementsByClassName('featured_cruises')[0];
    if (response.data.length > 0) {
      container.innerHTML = getNavSectionList(response.data, 'Cruise Lines', 'cl', 'cruiselines');
      container.style.display = 'block';
    } else {
      container.style.display = 'none';
    }
  }
});
let OSName = 'Unknown OS';
if (navigator.appVersion.indexOf('Win') !== -1) OSName = 'Windows';
else if (navigator.appVersion.indexOf('Mac') !== -1) OSName = 'MacOS';

function navCheckWidth () {
  const windowWidth = $(this).width();
  if (OSName === 'MacOS') {
    if (windowWidth <= 720) { // this is the same as 720px with vertical scrollbars added
      $('#navigation').hide();
      $('#navigation').addClass('mobile-nav');
      $('#navigation').removeClass('normal-nav');
    } else if (windowWidth > 720) {
      $('#navigation').show();
      $('#navigation').addClass('normal-nav');
      $('#navigation').removeClass('mobile-nav');
    }
  } else {
    if (windowWidth <= 703) { // this is the same as 720px with vertical scrollbars added
      $('#navigation').hide();
      $('#navigation').addClass('mobile-nav');
      $('#navigation').removeClass('normal-nav');
    } else if (windowWidth > 703) {
      $('#navigation').show();
      $('#navigation').addClass('normal-nav');
      $('#navigation').removeClass('mobile-nav');
    }
  }
}

$('#app_search_button, #search').on('click', function () {
  $('#search_drop').slideToggle();
});

let currWidth = $(window).width();
$(window).on('resize', function () {
  if ($(window).width() !== currWidth) {
    navCheckWidth();
    currWidth = $(window).width();
  }
});

(function () {
  navCheckWidth();
})();
